import { COMPANY_ADDRESS_FULL, MAP_URL } from '../constants';
import SectionHeading from './section-heading';

function LocationSection() {
  return (
    <section id="location" className="bg-fd-ink text-fd-paper">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-20 md:grid-cols-[0.9fr_1.1fr] md:items-center">
        <SectionHeading eyebrow="Company Address" title="469 Literary Road Suite 2." invert>
          This address is copied from the FEVERDREAM source file.
        </SectionHeading>
        <div className="border border-fd-line bg-fd-paper p-4 text-fd-ink shadow-document">
          <div className="border-2 border-fd-ink p-6">
            <p className="text-xs font-black uppercase tracking-[0.24em] text-fd-blue">Company Address</p>
            <p className="mt-5 font-serif text-3xl font-black leading-tight">{COMPANY_ADDRESS_FULL}</p>
            <a
              href={MAP_URL}
              aria-label="Open FEVERDREAM address in Google Maps"
              target="_blank"
              rel="noreferrer"
              className="mt-8 inline-flex border-2 border-fd-ink bg-fd-ink px-6 py-3 font-black text-fd-ivory transition hover:bg-fd-paper hover:text-fd-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-fd-blue focus-visible:ring-offset-2 focus-visible:ring-offset-fd-paper"
            >
              Open map
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LocationSection;
